import React, { Component } from 'react';
import { withLocalize } from "react-localize-redux";
import { Divider } from '@mantine/core';
import { Text } from '@mantine/core';
import _ from 'lodash';

class BarChartExperience extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: this.props.data.sort (function (a, b) { return a.Count - b.Count; }),
      width: 300,
      height: 240,
      color: "rgb(235, 79, 30)"
    }
  }

  componentDidMount() {
    if (this.props.data) {
      this.setState({
        data: this.props.data.sort((a, b) => a.Count - b.Count),
      }, () => {
        this.drawBars(this.findMax());
      });
    }
  }
  

  componentDidUpdate(prevProps, prevState ) {
    if (this.props.data !== prevProps.data ) {
      this.setState({
        data: this.props.data.sort (function (a, b) { return a.Count - b.Count; }),
      })
    }

    if (this.state.data !== prevState.data ) {
      this.drawBars(this.findMax());
    }
  }

  drawBars = (range) => {
    const minBarWidth = 1;
    const maxBarWidth = 350;
    this.state.data.map(level => {
      var bar =  document.getElementById(level.Variable)
      if(bar){
        const normalizedWidth = ((level.Count / range) * (maxBarWidth - minBarWidth)) + minBarWidth;
        bar.style.width = Math.round(normalizedWidth) + "px";
      }
      return level;
    })
  }

  findMax(){
    let max = 0
    const counted = this.props.data
    if(counted){
      _.forEach( counted, function (count) {
        if (max < count.Count) { max = count.Count; }
      });
    }
    return (max)
  }

  render() {
    let range = 0
    const counted = this.props.data
    let noneDefined;
    if(counted){
      _.forEach( counted, function (count) {
        range = range + count.Count;
      });
      _.forEach( counted, function (count) {
        if(count.Variable === ""){
          noneDefined = (count.Count/range)*100
        }
      });
    }
     
    return (
      <div style={{ display: "flex", margin: "0px"}} >
        <div>
          {this.props.data ? 
          <>
            {this.state.data.map((level,i) => 
              <div key={level+i}  >
              {  level.Variable.length > 0 ? 
              <>
                <div
                  style={{
                  width: "395px",
                  //height: this.state.height / this.props.data.length + "px",
                  height: 25 + "px",
                  margin: "0px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between"}}
                  >
                  <span style={{ color: this.state.color , marginRight: "5px" }} > {this.props.translate(`content.extract.dashboard.chart.seniority.${level.Variable}`)} </span>
                  <div
                    style={{
                      width: this.state.width + "px",
                      borderRadius: "5px",
                      display:"flex",
                      justifyContent: "center"
                    }}>
                    <div
                      id={level.Variable}
                      title={`Consultant: ${level.Count}`}
                      style={{
                        display:"flex",
                        color: "white",
                        justifyContent: "center",
                        alignItems: "center",
                        //backgroundColor: this.state.color,
                        backgroundColor: "rgb(235, 79, 30)",
                        transition: "all 0.5s ease-in",
                        width: "0px",
                        borderRadius: "5px",
                        height:"36px", 
                    }}>

                      {/*  {level.Count > 24 ? Math.round(100*level.Count/range)+" %" : <span style={{ position: "absolute", color: "#989DA3" , marginLeft: "-35px" }}> {Math.round(level.Count)} % </span>}    */}
                      {Math.round( 100*level.Count/range)+" %"}
                    </div>
                  </div>
                </div>
                <Divider my="sm" />
              </>:<></>}
              </div>
            )}

          
            <Text c="dimmed">
              {this.props.translate('content.extract.dashboard.chart.undefined')} : {Math.round(noneDefined) + " %"}
            </Text>
          
          </> :<></>}

        </div>
      </div>
    )
  }
}

export default withLocalize(BarChartExperience)
